import { render, staticRenderFns } from "./shopApply.vue?vue&type=template&id=4233ae67&scoped=true&"
import script from "./shopApply.vue?vue&type=script&lang=js&"
export * from "./shopApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233ae67",
  null
  
)

export default component.exports